import { queryKeyFactory } from "@l2r-front/l2r-query"

export const CAMPAIGN_ROOT_QUERY_KEY = "campaign"

export const campaignQueryKeys = queryKeyFactory(CAMPAIGN_ROOT_QUERY_KEY, {
    project: (filters = {}) => [CAMPAIGN_ROOT_QUERY_KEY, "project", filters],
})
